import { Component, Input } from '@angular/core';
import { Provider } from 'app/core/models/provider.model';
import { keyedStatusOptions } from 'app/core/options/provider-status.opts';
import { ProviderNavComponent } from '../provider-nav/provider-nav.component';
import { RouterLink } from '@angular/router';

import { CopyToClipboardComponent } from '../../../shared/components/copy-to-clipboard/copy-to-clipboard.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { ProviderHeaderEditComponent } from '../provider-header-edit/provider-header-edit.component';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

import { FormsModule } from '@angular/forms';
import { ProviderDataReviewComponent } from '../provider-data-review/provider-data-review.component';
import { SpecialtyBadgesComponent } from '../../../shared/components/specialty-badges/specialty-badges.component';

@Component({
    selector: 'app-provider-header',
    templateUrl: './provider-header.component.html',
    styleUrls: ['./provider-header.component.scss'],
    imports: [ProviderNavComponent,
              RouterLink,
              CopyToClipboardComponent,
              FaIconComponent,
              ProviderHeaderEditComponent,
              BlankValueDashPipe,
              FormsModule,
              ProviderDataReviewComponent,
              SpecialtyBadgesComponent]
})

export class ProviderHeaderComponent {
  @Input() provider: Provider;
  @Input() showProviderDataReview: boolean;

  editing = false;
  keyedStatusOptions = keyedStatusOptions;

  onEdit($event) {
    $event.preventDefault();
    this.editing = true;
  }

  onEditDetailsCancel() {
    this.editing = false;
  }

  onUpdatedDetails(provider: Provider) {
    this.editing = false;
    this.provider = provider;
  }
}
